module.exports = __webpack_public_path__ + "static/media/sidenav-icon-brands.d6922eb4.svg";